import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { ProgressComponent } from '../../app/shared/components/progress/progress.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { DirectsupplierContractPopupComponent } from './components/directsupplier-contract-popup/directsupplier-contract-popup.component';
import { ConfirmDialogComponent } from './components/confirm/confirm.dialog';
import { AlertComponent } from './components/alert/alert.component';
import { DeletsSiteConfirmComponent } from './components/delets-site-confirm/delets-site-confirm.component';

@NgModule({
  declarations: [ProgressComponent, PageNotFoundComponent, DirectsupplierContractPopupComponent, ConfirmDialogComponent, AlertComponent, DeletsSiteConfirmComponent],
  imports: [
    CommonModule, MatProgressBarModule, MatSelectModule, MatCardModule, MatSidenavModule,
    MatCheckboxModule, MatRadioModule, MatDatepickerModule,
    MatNativeDateModule, MatFormFieldModule, MatProgressBarModule,
    MatInputModule, FormsModule, ReactiveFormsModule, MatDialogModule
  ],
  exports: [ProgressComponent, MatProgressBarModule]
})
export class SharedModule { }
